<template>
  <div>
    <a-card>
      <span slot="title">Master Issue</span>
      <div slot="extra" class="d-flex flex-row items-center">
        <span>Periode : </span>
        <a-month-picker
          placeholder="Select periode"
          v-model="periode"
          @change="onChangeDate"
          format="MMMM YYYY"
        />
        <a-button type="primary" @click="createIssue" icon="plus"
          >New Issue</a-button
        >
      </div>
      <div class="loading-container" :class="{ 'is-disabled': loading.list }">
        <a-row style="width: 100%;" type="flex">
          <a-col class="header" :span="1">NO</a-col>
          <a-col class="header" :span="5">ISSUE</a-col>
          <a-col class="header" :span="3">STATUS</a-col>
          <a-col class="header" :span="6">RESPONSE</a-col>
          <a-col class="header" :span="3">CREATE BY</a-col>
          <a-col class="header" :span="3">UPDATE BY</a-col>
          <a-col class="header" :span="3">ACTION</a-col>
        </a-row>
        <Container @drop="onDrop" non-drag-area-selector=".not-draggable">
          <Draggable v-for="(item, index) in items" :key="item.issue_id">
            <div :class="item.status == 1 ? 'not-draggable' : 'draggable-item'">
              <a-row style="width: 100%;" type="flex">
                <a-col class="detail middle" :span="1">{{ index + 1 }}</a-col>
                <a-col
                  class="detail left"
                  :span="5"
                  style="white-space: pre-wrap;"
                  >{{ item.issue }}</a-col
                >
                <a-col class="detail middle" :span="3">{{
                  item.status == 1 ? "Done" : "In progress"
                }}</a-col>
                <a-col
                  class="detail left"
                  :span="5"
                  style="white-space: pre-wrap;"
                >
                  {{ item.response }}
                </a-col>
                <a-col class="detail middle" :span="1">
                  <a-button
                    v-if="item.file_doc_nm"
                    size="large"
                    type="link"
                    icon="paper-clip"
                    @click="openFile(item.file_doc_nm)"
                  />
                </a-col>
                <a-col class="detail middle" :span="3">{{
                  moment(item.create_dt, "YYYY-MM-DD").format(
                    getDefaultDateFormat
                  ) +
                    " / " +
                    item.create_tlc
                }}</a-col>
                <a-col class="detail middle" :span="3">{{
                  moment(item.update_dt, "YYYY-MM-DD").format(
                    getDefaultDateFormat
                  ) +
                    " / " +
                    item.update_tlc
                }}</a-col>
                <a-col class="detail middle" :span="3">
                  <a-tooltip title="Edit Response">
                    <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="check"
                      @click="resolveIssue(item)"
                    />
                  </a-tooltip>
                  <a-tooltip title="Edit Issue">
                    <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="edit"
                      @click="updateIssue(item)"
                    />
                  </a-tooltip>
                  <a-tooltip title="Delete Issue">
                    <a-popconfirm
                      title="Are you sure do you want to delete this issue?"
                      ok-text="Yes"
                      cancel-text="No"
                      @confirm="handleDelete(item.issue_id, item.periode)"
                    >
                      <a-button
                        size="small"
                        type="danger"
                        shape="circle"
                        icon="delete"
                      />
                    </a-popconfirm>
                  </a-tooltip>
                  <a-tooltip
                    title="Continue into next month"
                    v-if="item.status != 1"
                  >
                    <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="forward"
                      @click="forwardIssue(item.issue_id)"
                    />
                  </a-tooltip>
                </a-col>
              </a-row>
            </div>
          </Draggable>
        </Container>
      </div>
    </a-card>
    <a-modal
      :title="
        selectedValues.id
          ? mode == 'edit-response'
            ? 'Edit Response Issue'
            : 'Edit Issue'
          : 'Create New Issue'
      "
      :visible="visibleModal"
      @cancel="handleCancel"
      :footer="null"
      destroyOnClose
    >
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item name="periode" label="Periode">
          <a-month-picker
            v-decorator="[
              'periode',
              {
                rules: [{ required: true }],
                initialValue: selectedValues.periode
              }
            ]"
            format="MMMM YYYY"
            :disabled="mode != 'create'"
          />
        </a-form-item>
        <a-form-item name="isu" label="Issue">
          <a-textarea
            v-decorator="[
              'isu',
              {
                rules: [{ required: true, message: 'issue is required!' }],
                initialValue: selectedValues.isu
              }
            ]"
            :rows="2"
            :disabled="mode == 'edit-response'"
          />
        </a-form-item>
        <a-form-item
          v-if="mode == 'edit-response'"
          name="response"
          label="Response"
        >
          <a-textarea
            v-decorator="[
              'response',
              {
                rules: [{ required: true, message: 'response is required!' }],
                initialValue: selectedValues.response
              }
            ]"
            :rows="2"
          />
        </a-form-item>
        <a-form-item
          v-if="mode == 'edit-response'"
          name="file_upload"
          label="Attachment"
        >
          <a-upload
            :beforeUpload="beforeUpload"
            :fileList="uploadFileList"
            :multiple="false"
            :maxCount="1"
            :showUploadList="false"
          >
            <a-button size="small">
              Click to Upload
            </a-button>
          </a-upload>
          <a-form-item
            name="status"
            label="Status"
            v-if="mode == 'edit-response'"
          >
            <a-select
              v-decorator="[
                'status',
                {
                  rules: [{ required: true }],
                  initialValue: selectedValues.status
                }
              ]"
            >
              <a-select-option key="0" value="0">In Progress</a-select-option>
              <a-select-option key="1" value="1">Done</a-select-option>
            </a-select>
          </a-form-item>
          <span v-for="(item, index) in uploadFileList" :key="index">
            <a-button type="link" @click="openUploadFile(item)">{{
              item.name
            }}</a-button>
            <a-button type="danger" icon="delete" @click="removeUploadFile()" />
          </span>
          <span v-if="selectedValues.file_doc_nm">
            <a-button
              type="link"
              @click="openFile(selectedValues.file_doc_nm)"
              >{{ selectedValues.file_doc_nm }}</a-button
            >
            <a-button type="danger" icon="delete" @click="removeUploadFile()" />
          </span>
        </a-form-item>
        <a-form-item>
          <a-button @click="handleCancel">
            Cancel
          </a-button>
          <a-button
            type="primary"
            html-type="submit"
            :loading="loading.saveBtn"
          >
            Submit
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";
//import moment from "moment-business-days";
import moment from "moment";
import { Container, Draggable } from "vue-smooth-dnd";

export default {
  name: "master.issue",
  components: { Container, Draggable },
  data() {
    return {
      periode: null,
      items: [],
      loading: {
        list: false,
        saveBtn: false,
        copyBtn: false
      },
      selectedValues: {
        id: null,
        periode: null,
        isu: null,
        status: "0",
        response: null,
        file_doc_nm: null,
        file_deleted: null
      },
      visibleModal: false,
      form: this.$form.createForm(this, { name: "coordinated" }),
      isPortrait: window.innerHeight > window.innerWidth,
      uploadFileList: [],
      mode: ""
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat"])
  },

  mounted() {
    this.periode = moment();
    this.fetchData();
  },

  methods: {
    moment,
    async fetchData() {
      this.loading.list = true;
      try {
        const response = await Axios({
          method: "GET",
          url: this.$serviceUrl + "issue",
          params: {
            "X-API-KEY": this.getAuth.apikey,
            periode: moment(this.periode).format("YYYYMM")
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          }
        });
        if (response) {
          this.items = response.data.data;
        }
        this.loading.list = false;
      } catch (error) {
        this.loading.list = false;
        console.log(error);
      }
    },
    onChangeDate() {
      this.fetchData();
    },
    async applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }
      return result;
    },
    async onDrop(dropResult) {
      if (dropResult.removedIndex != dropResult.addedIndex) {
        const updatedIssue = {
          issue_id: this.items[dropResult.removedIndex].issue_id,
          periode: this.items[dropResult.removedIndex].periode,
          old_index: dropResult.removedIndex + 1,
          new_index: dropResult.addedIndex + 1
        };
        if (this.items[dropResult.addedIndex].status == 1) {
          return false;
        } else {
          this.items = await this.applyDrag(this.items, dropResult);
          await this.changePriorityData(updatedIssue);
        }
      }
    },
    async createIssue() {
      this.visibleModal = true;
      this.uploadFileList = [];
      this.selectedValues = {
        id: null,
        periode: this.periode,
        isu: null,
        status: null,
        response: null,
        file_doc_nm: null,
        file_deleted: null
      };
      this.mode = "create";
    },
    async updateIssue(item) {
      this.visibleModal = true;
      this.uploadFileList = [];
      this.selectedValues = {
        id: item.issue_id,
        periode: moment(item.periode, "YYYYMM"),
        isu: item.issue,
        status: item.status == null ? "0" : item.status,
        response: item.response,
        file_doc_nm: item.file_doc_nm,
        file_deleted: null
      };
      this.mode = "edit-issue";
    },
    async resolveIssue(item) {
      this.visibleModal = true;
      this.selectedValues = {
        id: item.issue_id,
        periode: moment(item.periode, "YYYYMM"),
        isu: item.issue,
        status: item.status == null ? "0" : item.status,
        response: item.response,
        file_doc_nm: item.file_doc_nm,
        file_deleted: null
      };
      this.mode = "edit-response";
    },
    handleCancel() {
      this.visibleModal = false;
      this.form.resetFields();
      this.mode = "";
      this.uploadFileList = [];
      this.selectedValues.file_doc_nm = null;
      this.selectedValues.file_deleted = true;
    },
    async insertData(newIssue) {
      try {
        this.loading.saveBtn = true;
        const response = await Axios({
          method: "post",
          url: this.$serviceUrl + "issue",
          processData: false,
          data: newIssue,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey
          }
        });
        if (response) {
          this.fetchData();
          this.loading.saveBtn = false;
          this.visibleModal = false;
          this.form.resetFields();
          this.$notification.success({
            message: "Success",
            description: "Issue created successfully",
            duration: 0.5
          });
          this.mode = "";
        }
      } catch (error) {
        this.loading.saveBtn = false;
        console.log(error);
        this.$notification.error({
          message: "Error",
          description: "An error occurred in the system"
        });
      }
    },
    async changePriorityData(updatedIssue) {
      try {
        this.loading.list = true;
        const response = await Axios({
          method: "put",
          url: this.$serviceUrl + "issue/reorder",
          processData: false,
          data: updatedIssue,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        });
        if (response) {
          this.loading.list = false;
        }
      } catch (error) {
        await this.fetchData();
        this.loading.list = false;
        this.$notification.error({
          message: "Error",
          description: "Gagal geser prioritas !"
        });
      }
    },
    async handleSubmit(e) {
      e.preventDefault();
      let sukses = false;
      let validValue = null;
      this.form.validateFields((err, values) => {
        if (!err) {
          sukses = true;
          validValue = values;
        }
      });
      console.log(validValue);
      console.log(this.selectedValues);
      if (sukses) {
        let newIssue = new FormData();
        if (this.selectedValues.id) {
          newIssue.append("issue_id", this.selectedValues.id);
        }
        newIssue.append("periode", moment(validValue.periode).format("YYYYMM"));
        newIssue.append("issue", validValue.isu);
        newIssue.append(
          "status",
          validValue.status ? validValue.status : this.selectedValues.status
        );
        newIssue.append(
          "response",
          validValue.response
            ? validValue.response
            : this.selectedValues.response
        );

        if (this.uploadFileList && this.uploadFileList.length > 0) {
          newIssue.append("file_upload", this.uploadFileList[0]);
        }
        if (this.selectedValues.file_deleted) {
          newIssue.append("file_deleted", true);
        }
        await this.insertData(newIssue);
      }
    },
    async handleDelete(issue_id, periode) {
      try {
        this.loading.list = true;
        const response = await Axios({
          method: "delete",
          url: this.$serviceUrl + "issue",
          processData: false,
          data: {
            issue_id: issue_id,
            periode: periode
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        });
        if (response) {
          await this.fetchData();
          this.loading.list = false;
          this.$notification.success({
            message: "Success",
            description: "Issue deleted successfully",
            duration: 0.5
          });
        }
      } catch (error) {
        this.loading.list = false;
        console.log(error);
        this.$notification.error({
          message: "Error",
          description: "An error occurred in the system"
        });
      }
    },
    async forwardIssue(issue_id) {
      let forwardedIssue = new FormData();
      forwardedIssue.append("issue_id", issue_id);
      try {
        this.loading.list = true;
        const response = await Axios({
          method: "post",
          url: this.$serviceUrl + "issue/forward",
          processData: false,
          data: forwardedIssue,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey
          }
        });
        if (response) {
          this.loading.list = false;
          this.$notification.success({
            message: "Success",
            description: "Issue created successfully",
            duration: 0.5
          });
        }
      } catch (error) {
        this.loading.list = false;
        console.log(error);
        this.$notification.error({
          message: "Error",
          description: "Terjadi kesalahan dalam sistem"
        });
      }
    },
    beforeUpload(file) {
      const maxSizeInBytes = 20 * 1024 * 1024;
      const isLtMaxSize = file.size <= maxSizeInBytes;

      if (!isLtMaxSize) {
        this.$notification.error({
          message: "Error",
          description: "Upload file maximal 20 MB"
        });
        return false; // Blocks upload
      }

      this.uploadFileList = [file];
      this.selectedValues.file_doc_nm = null;
      this.selectedValues.file_deleted = null;
      return false;
    },
    removeUploadFile() {
      this.uploadFileList = [];
      this.selectedValues.file_doc_nm = null;
      this.selectedValues.file_deleted = true;
    },
    openUploadFile(file) {
      let url = window.URL.createObjectURL(file);
      window.open(url, "_blank");
    },
    openFile(filename) {
      let url =
        process.env.VUE_APP_SERVICEURL + "assets/upload/issue/" + filename;
      window.open(url, "_blank");
    }
  }
};
</script>

<style lang="less">
.draggable-item {
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 50px;
  background-color: white;
  outline: 0;
  border: 0px;
  padding: 0px !important;
  margin-bottom: 0px;
  margin-top: 0px;
  cursor: pointer;
  user-select: none;
}

.not-draggable {
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 50px;
  background-color: white;
  outline: 0;
  border: 0px;
  padding: 0px !important;
  margin-bottom: 0px;
  margin-top: 0px;
  cursor: default;
  user-select: none;
}

.ant-row-flex {
  min-height: inherit;
  width: 100%;
  border: 0px;
}

.ant-col.header {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  border: 1px;
  border-style: solid;
  background-color: #30a679;
  color: white;
  font-weight: bold;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.ant-col.detail {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  min-height: inherit;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.ant-col.detail.left {
  padding-left: 3px;
}

.ant-col.detail.middle {
  justify-content: center;
}

.loading-container.is-disabled {
  pointer-events: none;
  opacity: 0.7;
  z-index: -1;
}

.loading-container.is-disabled::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 1s ease-in-out infinite;
  z-index: 1;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.ant-btn {
  margin-right: 2px;
  margin-left: 2px;
}

.ant-modal-header {
  padding-top: 10px !important;
  padding-right: 16px !important;
  padding-left: 16px !important;
  padding-bottom: 10px !important;
}

.ant-modal-body {
  padding-top: 0px !important;
  padding-right: 16px !important;
  padding-left: 16px !important;
  padding-bottom: 10px !important;
}

.ant-form-item-label {
  line-height: 30px !important;
}
</style>
